import { useFormik } from 'formik';
import Link from 'next/link';
import { useState } from 'react';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import AlertManager from '../../../../../shared/components/global/AlertManager';
import { InputRowDual } from '../../../../../shared/styles/backend/container';
import { Button, ButtonSizes } from '../../../../../shared/styles/button';
import { CheckboxContainer, Container, ContainerContentStandard } from '../../../../../shared/styles/container';
import { Headline, SubHeadline } from '../../../../../shared/styles/headline';
import { Checkbox, Input, InputTextbox, RequiredSignWrapper, Select, SelectTextbox, Textarea } from '../../../../../shared/styles/input';

const InputRowSingle = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  width: 100%;
  margin-bottom: 1rem;
`;
const ACForm = styled.form`
    max-width: 650px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 64px;

    label {
        text-align: left;
    }
`;

export const ActiveCampaignForm = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [formSubmitted, setFormSubmitted] = useState(false)

    const formik = useFormik({
        initialValues: {
            anrede: '',
            lastname: '',
            firstname: '',
            position: '',
            firma: '',
            anfrage: '',
            phone: '',
            checkbox: false,
            email: '',
        },
        validationSchema: Yup.object({
            lastname: Yup.string()
                .required('Pflichtfeld.'),
            firstname: Yup.string()
                .required('Pflichtfeld.'),
            firma: Yup.string()
                .required('Pflichtfeld.'),
            anfrage: Yup.string()
                .max(1000),
            checkbox: Yup.string()
                .required('Pflichtfeld.'),
            email: Yup.string()
                .email()
                .required('Pflichtfeld.'),
        }),

        onSubmit: (values: any) => {
            setLoading(true)
            let formData: FormData = new FormData();

            formData.append("u", "1");
            formData.append("f", "1");
            formData.append("s", "");
            formData.append("c", "0");
            formData.append("m", "0");
            formData.append("act", "sub");
            formData.append("v", "2");
            formData.append("or", "2295c0c902f12f6b9dd86367f03f4ab0");
            formData.append("jsonp", "true");

            for (var key in values) {
                let acKey = key;
                if (key === 'firma') {
                    acKey = "field[2]";
                } else if (key === 'anrede') {
                    acKey = "field[3]";
                } else if (key === 'checkbox') {
                    acKey = "field[4][]";
                    formData.append(acKey, "~|");
                    formData.append(acKey, "Ich bin damit einverstanden, per E-Mail und telefonisch Informationen zum SME-Talentpool bis auf Widerruf zu erhalten. Die Datenschutzhinweise habe ich zur Kenntnis genommen.");
                    continue;
                } else if (key === 'anfrage') {
                    acKey = "field[5]";
                } else if (key === 'position') {
                    acKey = "field[7]";
                }
                formData.append(acKey, values[key]);
            }

            fetch("https://easyboarding.activehosted.com/proc.php", {
                method: "POST",
                body: formData,
                mode: "no-cors",
            })
                .then(() => {
                    setLoading(false);
                    setFormSubmitted(true);
                    setTimeout(() => {
                        setFormSubmitted(false);
                    }, 5000);
                    formik.resetForm();
                    Swal.fire(AlertManager.ActiveCampaignMessageSuccess());
                })
                .catch(error => {
                    setLoading(false);
                    Swal.fire(AlertManager.ActiveCampaignMessageError(error, formData));
                    console.error("Request failed", error);
                });
        },
    });

    return (
        <Container centered id="contact">
            <ContainerContentStandard>
                <Headline>Jetzt unverbindlich anfragen</Headline>
                <SubHeadline>Optimieren Sie Ihr Recruiting über die Bewerberakquise mit den Recruitingangeboten von easyboarding:</SubHeadline>
                <ACForm onSubmit={formik.handleSubmit}>
                    <InputRowSingle>
                        <SelectTextbox>
                            <Select
                                id="anrede"
                                className={`${formik.values.anrede?.length > 0 ? "form-dropdown-select " : "form-dropdown-selectnone"} form-dropdown-input`}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="anrede"
                                value={formik.values.anrede}
                                error={formik.touched?.anrede && formik.errors?.anrede != null}
                            >
                                <option value=""></option>
                                <option value="Herr">Herr</option>
                                <option value="Frau">Frau</option>
                            </Select>
                            <span className='form-dropdown-label'>Anrede</span>
                        </SelectTextbox>
                    </InputRowSingle>
                    <InputRowDual>
                        <InputTextbox>
                            <Input
                                id="firstname"
                                className={`${formik.values.firstname?.length > 0 ? "form-textbox-entered " : ""} form-textbox-input`}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="firstname"
                                type="text"
                                value={formik.values.firstname}
                                error={formik.touched?.firstname && formik.errors?.firstname != null}
                            />
                            <span className='form-textbox-label'>Vorname<RequiredSignWrapper>*</RequiredSignWrapper></span>
                        </InputTextbox>
                        <InputTextbox>
                            <Input
                                id="lastname"
                                className={`${formik.values.lastname?.length > 0 ? "form-textbox-entered " : ""} form-textbox-input`}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="lastname"
                                type="text"
                                value={formik.values.lastname}
                                error={formik.touched?.lastname && formik.errors?.lastname != null}
                            />
                            <span className='form-textbox-label'>Nachname<RequiredSignWrapper>*</RequiredSignWrapper></span>
                        </InputTextbox>
                    </InputRowDual>
                    <InputRowDual>
                        <InputTextbox>
                            <Input
                                id="firma"
                                className={`${formik.values.firma?.length > 0 ? "form-textbox-entered " : ""} form-textbox-input`}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="firma"
                                type="text"
                                value={formik.values.firma}
                                error={formik.touched?.firma && formik.errors?.firma != null}
                            />
                            <span className='form-textbox-label'>Firma<RequiredSignWrapper>*</RequiredSignWrapper></span>
                        </InputTextbox>
                        <InputTextbox>
                            <Input
                                id="position"
                                className={`${formik.values.position?.length > 0 ? "form-textbox-entered " : ""} form-textbox-input`}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="position"
                                type="text"
                                value={formik.values.position}
                                error={formik.touched?.position && formik.errors?.position != null}
                            />
                            <span className='form-textbox-label'>Position</span>
                        </InputTextbox>
                    </InputRowDual>
                    <InputRowSingle>
                        <InputTextbox>
                            <Input
                                id="phone"
                                className={`${formik.values.phone?.length > 0 ? "form-textbox-entered " : ""} form-textbox-input`}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="phone"
                                type="text"
                                value={formik.values.phone}
                                error={formik.touched?.phone && formik.errors?.phone != null}
                            />
                            <span className='form-textbox-label'>Telefon</span>
                        </InputTextbox>
                    </InputRowSingle>
                    <InputRowSingle>
                        <InputTextbox>
                            <Input
                                id="email"
                                className={`${formik.values.email?.length > 0 ? "form-textbox-entered " : ""} form-textbox-input`}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="email"
                                type="text"
                                value={formik.values.email}
                                error={formik.touched?.email && formik.errors?.email != null}
                            />
                            <span className='form-textbox-label'>E-Mail<RequiredSignWrapper>*</RequiredSignWrapper></span>
                        </InputTextbox>
                    </InputRowSingle>
                    <InputRowSingle>
                        <Textarea
                            id="anfrage"
                            name="anfrage"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Geben Sie Ihre Anfrage hier ein, z.B. Ich habe Interesse Partner des Speed-Recruiting-Events zu werden. Ich wünsche eine Live-Demo des Talentpools. etc."
                            value={formik.values.anfrage}
                            error={formik.touched.anfrage && formik.errors.anfrage != null}
                            rows={8}
                        />
                    </InputRowSingle>
                    <InputRowSingle>
                        <CheckboxContainer>
                            <Checkbox
                                id="checkbox"
                                name="checkbox"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                type="checkbox"
                                checked={formik.values.checkbox}
                                error={formik.touched.checkbox && formik.errors.checkbox != null}
                                big={true}
                            />
                            <label htmlFor="checkbox">
                                Hiermit bestätige ich, dass ich die <Link href="/datenschutz">Datenschutzerklärung</Link> zur Kenntnis genommen habe. Die Verarbeitung meiner personenbezogenen Daten kann ich jederzeit widerrufen.*
                            </label>
                        </CheckboxContainer>
                    </InputRowSingle>
                    <InputRowSingle>
                        <Button disabled={loading || !formik.isValid || !formik.values.checkbox} $loading={loading} size={ButtonSizes.m} primary type="submit">
                            Abschicken
                        </Button>
                    </InputRowSingle>
                </ACForm>
            </ContainerContentStandard >
        </Container>
    );

}
